<!--
账号设置
-->
<template>
  <div class="box-page">
    <div class="box-title-line">
      <div class="box-title title-line">账号设置</div>
    </div>
    <div class="account-container" v-loading="loading">
      <el-form :model="form" label-width="80px" label-position="left">
        <div class="title">头像昵称修改</div>
        <div class="flex-col-center">
          <el-upload class="avatar-uploader" :action="baseUrl" :show-file-list="false" :headers="headers"
            :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess">
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="margin-left: 25px">点击头像上传新头像</div>
        </div>
        <el-form-item label="员工姓名" style="margin: 55px 0 70px 0">
          <el-input v-model="form.nickname" placeholder="请输入姓名" disabled></el-input>
        </el-form-item>
        <div class="title">密码设置</div>
        <el-form-item label="当前密码">
          <el-input v-model="form.oldPwd" show-password placeholder="请输入当前密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.nowPwd" show-password placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="form.confirmPwd" show-password placeholder="请输入再次输入新密码"></el-input>
        </el-form-item>
        <div class="box-btn" style="width: 200px; margin-left: 80px" @click="save">
          确认修改
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      form: {
        avatar: '',
        nickname: '',
        oldPwd: '',
        nowPwd: '',
        confirmPwd: ''
      },
      baseUrl: '',
	  headers: {}
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    userType() {
      return this.$store.state.user.userType
    }
  },
  watch: {},
  mounted() {
    this.baseUrl = process.env.VUE_APP_SERVER_URL + '/clientApi/common/uploadFile';
	const TOKEN = sessionStorage.getItem('token');
	this.headers = {userToken: TOKEN};
    this.form = this.$store.state.user.userInfo
  },
  methods: {
    save() {
      if (!this.form.avatar) {
        this.$notify.error({
          title: '提示',
          message: '请上传头像'
        })
        return
      }
      if (!this.form.nickname) {
        this.$notify.error({
          title: '提示',
          message: '昵称不能为空'
        })
        return
      }
      if (
        this.form.nowPwd &&
        this.form.confirmPwd &&
        this.form.nowPwd != this.form.confirmPwd
      ) {
        this.$notify.error({
          title: '提示',
          message: '两次密码输入不一致'
        })
        return
      }

      this.loading = true
      this.$api.system
        .updateUserInfo({
          avatar: this.form.avatar,
          nickname: this.form.nickname,
          oldPassword: this.form.oldPwd,
          newPassword: this.form.confirmPwd
        })
        .then(({ data }) => {
          this.loading = false
          if (data.code == 200) {
            this.$notify.success({
              title: '提示',
              message: `修改成功${
                this.userInfo.isChangePassword === '0' ? '，请重新登录' : ''
              }`
            })
            setTimeout(async () => {
              await this.$store.dispatch('user/resetAuth')
              this.$router.push({ path: '/login' })
            }, 1000)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isLt5M
    },

    handleAvatarSuccess(res) {
      this.form.avatar = res.data[0].fileUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.account-container {
  margin-top: 75px;
  margin-left: 30px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #434a66;
  .title {
    margin-bottom: 34px;
    font-family: Microsoft YaHei;
    color: #40424f;
    font-weight: bold;
    font-size: 18px;
  }
  /deep/ .el-form-item__content {
    width: 330px;
  }
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
  object-fit: cover;
}
</style>
